import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';

import decorate from 'widget/utils/decorate';
import { playVideo } from 'widget/redux/client/actions/change-playback-status';
import { selectVideo } from 'widget/redux/client/actions/select-video';

import InFrameActions from './in-frame';


@connect(null, {
  playVideo,
  selectVideo,
})
@decorate(InFrameActions)
export default class InFrameMobileActions extends React.Component {
  static propTypes = {
    children: React.PropTypes.element.isRequired,
    selectVideo: React.PropTypes.func.isRequired,
    playVideo: React.PropTypes.func.isRequired,
    channelId: React.PropTypes.string,
    videoId: React.PropTypes.string,
    isMainVideo: React.PropTypes.string,
  };

  @autobind
  selectVideo() {
    const { selectVideo, videoId } = this.props;
    return selectVideo(videoId);
  }

  @autobind
  playVideo() {
    const { playVideo, videoId } = this.props;
    return playVideo(videoId);
  }

  render() {
    const { children, isMainVideo } = this.props;
    const inFrameActions = _.omit(this.props, this.propTypes);

    return React.cloneElement(children, {
      ...inFrameActions,
      onPlayRequest: isMainVideo ? this.playVideo : this.selectVideo,
    });
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/actions/overlay-actions/in-frame-mobile.js